<template>
  <div class="">
    <a-popover
      overlayClassName="no-padding"
      :placement="$attrs.placement"
      arrowPointAtCenter
      :trigger="$attrs.trigger ? $attrs.trigger : '`hover`'"
    >
      <template v-if="title" slot="title"> <slot name="title" /> </template>
      <template slot="content"> <slot name="body" /> </template>
      <base-button
        id="trigger-button"
        :loading="$attrs.loading"
        :disabled="$attrs.disabled"
        :size="$attrs.size"
        :context="$attrs.context"
        tooltip=""
      >
        <slot />
        <template #after>
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </template>
      </base-button>
    </a-popover>
  </div>
</template>

<script>
import {BaseIcon, BaseButton} from './'
import {btnStyle} from '@/state/helpers/mixins.js'
import Popover from 'ant-design-vue/lib/popover'
import 'ant-design-vue/lib/popover/style/index.css'

export default {
  props: {
    title: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
    'a-popover': Popover,
    BaseButton,
  },
  mixins: [btnStyle],
  data() {
    return {visible: false}
  },
}
</script>
<style>
.no-padding .ant-popover-inner-content {
  padding: 0;
}
</style>
